/**
 * Load page HTML from a Vite-inlined .txt string or a legacy fetchable URL.
 * CRA exposed .txt imports as asset URLs; Vite inlines them as string content.
 */
export const readUrl = (urlOrContent) => {
  return new Promise((resolve, reject) => {
    if (typeof urlOrContent !== "string") {
      reject(new Error("readUrl: expected string"));
      return;
    }

    const trimmed = urlOrContent.trimStart();
    const isHtmlContent =
      trimmed.startsWith("<") ||
      urlOrContent.includes("<!DOCTYPE") ||
      urlOrContent.includes("<html") ||
      urlOrContent.includes("<div") ||
      urlOrContent.includes("<svg") ||
      urlOrContent.includes("<body");

    const isFetchableUrl =
      /^https?:\/\//i.test(urlOrContent) ||
      urlOrContent.startsWith("blob:") ||
      urlOrContent.startsWith("data:") ||
      (urlOrContent.startsWith("/") && !isHtmlContent);

    if (isHtmlContent || !isFetchableUrl) {
      resolve(urlOrContent);
      return;
    }

    fetch(urlOrContent)
      .then((response) => response.text())
      .then(resolve)
      .catch(reject);
  });
};
